import styled from 'styled-components/macro';

export const Subtitle = styled.span`
  color: var(--gray);
  display: block;
`;

export const BtnHolder = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
  margin-top: 20px;
`;
